import { GraphQLDebugInfo, GraphQLResponse } from '../lib/types';

const shouldLog = (): boolean => {
  const isTest = process.env.NODE_ENV === 'test';
  if (isTest) {
    return false;
  }

  const hasServerDebugEnv = process.env.SHOW_GRAPHQL_DEBUG === 'true';
  const hasClientDebugEnv =
    process.env.NEXT_PUBLIC_SHOW_GRAPHQL_DEBUG === 'true';

  if (typeof window !== 'undefined') {
    const hasDebugCookie = document.cookie
      .split('; ')
      .some((cookie) => cookie === 'show_debug_info=1');

    return hasClientDebugEnv || hasServerDebugEnv || hasDebugCookie;
  }

  return hasServerDebugEnv || hasClientDebugEnv;
};

/** Логирует debug информацию из GraphQL ответа в консоль */
export const logGraphQLDebug = <T>(
  response: GraphQLResponse<T>,
  operationName?: string
): void => {
  if (!shouldLog() || !response.debugInfo) {
    return;
  }

  const debugInfo = response.debugInfo as GraphQLDebugInfo;
  const logPrefix = `[GraphQL Debug${operationName ? `: ${operationName}` : ''}]`;

  // eslint-disable-next-line no-console
  console.group(logPrefix);
  // eslint-disable-next-line no-console
  console.log('Operation Name:', debugInfo.operationName);
  // eslint-disable-next-line no-console
  console.log('Status Code:', debugInfo.statusCode);
  if (debugInfo.url) {
    // eslint-disable-next-line no-console
    console.log('URL:', debugInfo.url);
  }
  if (debugInfo.requestMethod) {
    // eslint-disable-next-line no-console
    console.log('Request Method:', debugInfo.requestMethod);
  }
  if (debugInfo.requestHeaders) {
    // eslint-disable-next-line no-console
    console.log('Request Headers:', debugInfo.requestHeaders);
  }
  if (response.query) {
    // eslint-disable-next-line no-console
    console.log('Query:', response.query);
  }
  // eslint-disable-next-line no-console
  console.log('Variables:', debugInfo.variables);
  if (response.errors) {
    // eslint-disable-next-line no-console
    console.error('Errors:', response.errors);
  }
  if (response.data) {
    // eslint-disable-next-line no-console
    console.log('Response Data:', response.data);
  }
  // eslint-disable-next-line no-console
  console.groupEnd();
};
